/**
 * General Ledger Account Formatter Formatter.
 * @param {*} value
 * @param {object} row
 * @returns {string}
 */
window.generalLedgerAccountFormatter = function(value, row) {
    let html = '';
    if (value) {
        html += '<a href="/admin/settings/general-ledger-accounts/show/'+row.id+'">';
        html += value;
        html += '</a>';
    }
    return html;
}
